const data = [
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "pending"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "reconcilled"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "reconcilled"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "pending"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "unreconcilled"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "unreconcilled"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "pending"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "unreconcilled"
    },
    {
        name: "apple Mac book 15 250 ssd 128Gb",
        price: 7350,
        transactionNo: 1234567890,
        createdon: "12:30",
        status: "unreconcilled"
    }
]

export default data;